module.exports = __webpack_public_path__ + "img/DK12719280.385d82f9.png";